<div class="container-fluid p-5">
  <div class="row d-flex align-items-end justify-content-end" [hidden]="sharedService.isStaff()">
    <div class="col-5 col-md-3 col-lg-2">
      <!--here-->
      <app-add-other-transactions-menu [companyBankAccountList]="companyBankAccountList" [cashAccountList]="cashAccountList"></app-add-other-transactions-menu>
    </div>
    @if (sharedService.isBranchManager()) {
      <div class="col-6 col-md-3 col-lg-2">
        <button class="btn btn-primary" (click)="openAddAccountDialog()"><i class="fas fa-plus"></i> Add Account</button>
      </div>
    }
  </div>

  <div [hidden]="sharedService.isStaff()">
    <h3><strong>Duit Lebih</strong></h3>
    <h4 style="color: blueviolet">
      <strong>Balance : {{ duitLebihBalance || 0 }}</strong>
    </h4>
    <hr />
  </div>

  <div [hidden]="sharedService.isStaff()">
    <h3>Company Account</h3>

    @if (companyBankAccountList.length == 0) {
      <p>Currently no bank account for this company</p>
    } @else {
      <div class="row">
        @for (bankAccount of companyBankAccountList; track bankAccount) {
          <div class="col-12 col-md-4">
            <div class="card companyAccount-card m-1" (click)="openTransactionHistoryModal(bankAccount.ID)">
              <div class="card-header">
                <strong>{{ bankAccount.Name }}</strong>
              </div>
              <div class="card-body companyAccount-card-body">
                <p>Number: {{ bankAccount.AccountNumber }}</p>
                <p>Holder: {{ bankAccount.HolderName }}</p>
                <p>Balance : {{ bankAccount.Balance || 0 | number: "1.2-2" }}</p>
              </div>
            </div>
          </div>
        }
      </div>
    }

    <hr />
  </div>
  <h3>Cash Account</h3>

  @if (cashAccountList.length == 0) {
    <p>Currently no cash account for this company</p>
  } @else {
    <div class="row">
      @for (cashAccount of cashAccountList; track cashAccount) {
        <div class="col-12 col-md-4">
          <div class="card m-1 cashAccount-card" (click)="openTransactionHistoryModal(cashAccount.ID)">
            <div class="card-header">
              <strong>{{ cashAccount.Name }}</strong>
            </div>
            <div class="card-body cashAccount-card-body">
              <p>Username: {{ cashAccount.Username }}</p>
              <p>Balance : {{ cashAccount.Balance || 0 | number: "1.2-2" }}</p>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
